import request from '@/utils/request'

export function buildOperatorPageContext (route, surface) {
  if (!route) {
    return { surface: surface || 'soc_admin' }
  }
  const meta = route.meta || {}
  const menuId = meta.menuId != null ? String(meta.menuId) : (meta.id != null ? String(meta.id) : '')
  const pageTitle = typeof meta.title === 'string' ? meta.title : ''
  return {
    routePath: route.path || '',
    routeName: route.name || '',
    menuId: menuId,
    pageTitle: pageTitle,
    surface: surface || 'soc_admin'
  }
}

export function fetchOperatorSupportTopics (pageContext) {
  return request({
    url: '/coffee/leo/training/operator-support/topics',
    method: 'get',
    params: pageContext || {}
  })
}

export function askOperatorSupport (data) {
  return request({
    url: '/coffee/leo/training/operator-support/ask',
    method: 'post',
    data
  })
}

export function recordOperatorPageView (pageContext) {
  return request({
    url: '/coffee/leo/training/operator-support/page-view',
    method: 'post',
    data: { pageContext: pageContext || {} }
  })
}

export function feedbackOperatorSupport (data) {
  return request({
    url: '/coffee/leo/training/operator-support/feedback',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/leoTrainingOperatorSupport.js